var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormInput',{attrs:{"context":_vm.context}},[(_vm.componentExists)?_c(_vm.componentName,{tag:"component",attrs:{"context":_vm.context,"meta":_vm.meta}}):_c('PrimeVueMessage',{attrs:{"severity":"error"}},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }